import React from 'react';
import { NavLink } from "react-router-dom";
import { IoMdHome,IoIosList, IoIosConstruct, IoIosCart } from "react-icons/io";
import { useTranslation } from 'react-i18next';

import './HeaderNav.scss';

function HeaderNav() {
    const { t } = useTranslation();

    const dashboardActive = (match, location) => {
        const notificationsArchive = location.pathname.includes('/notifications');
        if (!match.isExact && !notificationsArchive) return false;
        return true;
    };

    return (
        <nav id="HeaderNav">
            <ul>
                <li>
                    <NavLink to="/" isActive={dashboardActive} activeClassName="active" className="d-flex">
                        <div><IoMdHome /></div> {t('header_nav.dasboard')}
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/events" activeClassName="active" className="d-flex">
                        <div><IoIosList /></div> {t('header_nav.events')}
                    </NavLink>
                </li>
                <li>
                    <NavLink to ="/orders" activeClassName="active" className="d-flex">
                        <div><IoIosCart /></div> {t('header_nav.orders')}
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/settings" activeClassName="active" className="d-flex">
                        <div><IoIosConstruct /></div> {t('header_nav.settings')}
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default HeaderNav;